import { all } from 'redux-saga/effects'
import tableSaga from './tableDataSaga'
import filterSaga from './filterSaga'
import csvDataSaga from './csvDataSaga';
import tmsMetaDataSaga from './tmsMetaDataSaga';
import saveStopEventsSaga from './saveStopEventsSaga';
import userInfoSaga from './userInfoSaga';
import retriggerEventSaga from './retriggerEventSaga';
import commentsSaga from './commentsSaga';
import addCommentSaga from './addCommentSaga';

/** Carrier Performance  */ 
import locationMetadataSaga from './locationMetadataSaga';
import carrierServiceMetadataSaga from './carrierServiceMetadataSaga';
import summarySaga from './summarySaga';
import carrierInfoSaga from './carrierInfoSaga';
import drmTableDataSaga from './drmTableDataSaga';
// import drmMasterDataSaga from './drmMasterDataSaga';
import drmLiveMasterDataSaga from './drmLiveMasterDataSaga';
import drmCustomColumnSaga from './drmCustomColumnSaga';
import drmExcelDataSaga from './drmExcelDataSaga';
import drmCoupaFileUploadSaga from './drmCoupaFileUploadSaga';
import drmUpdateTableDataSaga from './drmUpdateTableDataSaga';
import drmDeleteTableDataSaga from './drmDeleteTableDataSaga';
import drmSubmitTableDataSaga from './drmSubmitTableDataSaga';
import drmCreateTableDataSaga from './drmCreateTableDataSaga';
import drmChangeLogTableDataSaga from './drmChangeLogTableDataSaga';
import drmCEAZipDownloadSaga from './drmCEAZipDownloadSaga';
import drmDailyRecordCancelSaga from './drmDailyRecordCancelSaga';
import drmReportDetailsSaga from './drmReportDetailsSaga';
import drmCoupaFileDeleteDetailsSaga from './drmCoupaFIleDeleteDetailsSaga';
import drmCoupaDeleteSaga from './drmCoupaDeleteSaga';
import drmCoupaUpdateSaga from './drmCoupaUpdateSaga';
import drmCeaProfileListSaga from './drmCeaProfileListSaga';
import drmCeaProfileDownloadSaga from './drmCeaProfileDownloadSaga';
import drmInactiveCeaSaga from './drmInactiveCeaSaga';
import drmExpireTableDataSaga from './drmExpireTableDataSaga';
import drmCoupaExpireSaga from './drmCoupaExpireSaga';

/**
 * A root Saga aggregates multiple Sagas to a single entry point for the sagaMiddleware to run. 
 */
export default function* rootSaga() {
    yield all([
        /** Track & Trace  */ 
        tableSaga(),
        filterSaga(),
        csvDataSaga(),
        tmsMetaDataSaga(),
        saveStopEventsSaga(),
        userInfoSaga(),
        retriggerEventSaga(),
        commentsSaga(),
        addCommentSaga(),

        /** Carrier Performance  */ 
        locationMetadataSaga(),
        carrierServiceMetadataSaga(),
        summarySaga(),
        carrierInfoSaga(),

        /** DRMT */
        drmTableDataSaga(),
        //drmMasterDataSaga(),
        drmLiveMasterDataSaga(),
        drmCustomColumnSaga(),
        drmExcelDataSaga(),
        drmCoupaFileUploadSaga(),
        drmUpdateTableDataSaga(),
        drmDeleteTableDataSaga(),
        drmSubmitTableDataSaga(),
        drmCreateTableDataSaga(),
        drmChangeLogTableDataSaga(),
        drmCEAZipDownloadSaga(),
        drmDailyRecordCancelSaga(),
        drmReportDetailsSaga(),
        drmCoupaFileDeleteDetailsSaga(),
        drmCoupaDeleteSaga(),
        drmCoupaUpdateSaga(),
        drmCeaProfileListSaga(),
        drmCeaProfileDownloadSaga(),
        drmInactiveCeaSaga(),
        drmExpireTableDataSaga(),
        drmCoupaExpireSaga(),
        
    ]);
}